function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-grad-cta-hero\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.44,35.68H6.56a5.43,5.43,0,0,1-5.42-5.42V9.74A5.38,5.38,0,0,1,3.28,5.43a1.12,1.12,0,0,1,1.57.21,1.13,1.13,0,0,1-.21,1.58A3.14,3.14,0,0,0,3.39,9.74V30.26a3.18,3.18,0,0,0,3.17,3.17H33.44a3.18,3.18,0,0,0,3.17-3.17V9.74a3.2,3.2,0,0,0-1.39-2.63,1.12,1.12,0,0,1-.31-1.56,1.14,1.14,0,0,1,1.57-.3,5.42,5.42,0,0,1,2.38,4.49V30.26A5.43,5.43,0,0,1,33.44,35.68Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.11,29.42H16.89a3.61,3.61,0,0,1,0-7.22h6.22a3.61,3.61,0,0,1,0,7.22Zm-6.22-5a1.36,1.36,0,1,0,0,2.72h6.22a1.36,1.36,0,0,0,0-2.72Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20,12a1.7,1.7,0,0,1-.51-.07L6.79,8.21a1.06,1.06,0,0,1,0-2L19.48,2.52a2,2,0,0,1,1.08,0L33.24,6.18a1.06,1.06,0,0,1,0,2L20.52,11.88A1.68,1.68,0,0,1,20,12ZM9.68,7.2l10.32,3,10.35-3L20,4.22Zm23.07.69h0Zm-13-4.52h0Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,18.64a1.35,1.35,0,0,1-.72-.22,12.84,12.84,0,0,0-6.63-2.11,1.06,1.06,0,0,1-1.05-1.06V9A.89.89,0,0,1,13.4,9v5.61A15,15,0,0,1,20,16.77a14.8,14.8,0,0,1,6.62-2.2V9a.89.89,0,1,1,1.77,0v6.29a1.06,1.06,0,0,1-1.05,1.06,12.84,12.84,0,0,0-6.63,2.11A1.29,1.29,0,0,1,20,18.64Z",
  fill: "#231f20"
});

function SvgCmsGradCtaHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgCmsGradCtaHero;